import {DefaultTooltip, KeenIcon} from '@/components';
import {
    MenuItem,
    MenuLink,
    MenuSub,
    MenuTitle,
    MenuSeparator,
    MenuArrow,
    MenuIcon
} from '@/components/menu';
import {ChangeEvent, Fragment, useEffect} from 'react';
import {toAbsoluteUrl} from '@/utils';
import {DropdownUserLanguages} from './DropdownUserLanguages';
import {Link} from 'react-router-dom';
import {useSettings} from '@/providers/SettingsProvider';
import {useAuthContext} from '@/auth';
import {useUser} from "@/contexts/UserContext.tsx";
import {SessionTimer} from "@/auth/SessionTimer.tsx";

const DropdownUser = () => {
    const {settings, storeSettings} = useSettings();
    const {logout} = useAuthContext();

    const handleThemeMode = (event: ChangeEvent<HTMLInputElement>) => {
        console.log('checked:' + event.target.checked);
        const newThemeMode = event.target.checked ? 'dark' : 'light';

        storeSettings({
            themeMode: newThemeMode
        });
    };

    const buildHeader = () => {

        const {user, refreshUser} = useUser();

        useEffect(() => {
            // Refresh user data on component mount
            if (!user) {
                refreshUser();
            }
        }, [refreshUser]);

        if (!user) {
            return (<></>);
        }

        return (
            <div className="flex items-center justify-between px-5 py-1.5 gap-1.5">
                <div className="flex items-center gap-2">
                    <img
                        className="size-9 rounded-full border-2 border-success"
                        src={toAbsoluteUrl('/media/app/upflinx/logo_4c_mini_grey.svg')}
                        alt=""
                    />
                    <div className="flex flex-col gap-1.5">
                        <div className="text-sm text-gray-800 font-semibold leading-none"
                        >
                            {user.firstName} {user.lastName}
                        </div>
                        <div className="text-xs text-gray-600 font-medium leading-none">
                            {user.email}
                        </div>
                    </div>
                </div>
                <span className="badge badge-xs badge-primary badge-outline">Free</span>
            </div>
        );
    };

    const buildMenu = () => {
        return (
            <Fragment>
                <MenuSeparator/>
                <div className="flex flex-col">
                    <MenuItem>
                        <MenuLink path="/account/user">
                            <MenuIcon>
                                <KeenIcon icon="profile-circle"/>
                            </MenuIcon>
                            <MenuTitle>My Profile</MenuTitle>
                        </MenuLink>
                    </MenuItem>
                    {/*<DropdownUserLanguages />*/}
                    <MenuSeparator/>
                </div>
            </Fragment>
        );
    };

    const buildFooter = () => {
        return (
            <div className="flex flex-col">

                {/*<div className="menu-item mb-0.5">
          <div className="menu-link">
            <span className="menu-icon">
              <KeenIcon icon="moon" />
            </span>
            <span className="menu-title">Dark Mode</span>
            <label className="switch switch-sm">
              <input
                name="theme"
                type="checkbox"
                checked={settings.themeMode === 'dark'}
                onChange={handleThemeMode}
                value="1"
              />
            </label>
          </div>
        </div>*/}

                <div className="menu-item px-4 py-1.5">
                    <a onClick={logout} className="btn btn-sm btn-light justify-center">
                        Logout
                    </a>
                </div>
            </div>
        );
    };

    return (
        <MenuSub
            className="menu-default light:border-gray-300 w-[200px] md:w-[250px]"
            rootClassName="p-0"
        >
            {buildHeader()}
            {buildMenu()}
            {buildFooter()}
        </MenuSub>
    );
};

export {DropdownUser};
